// Exact pre-redesign defaults only; never private personnel content.
export const administrationLegacy = {
  "summary": "Clarifier les rôles administration haut niveau, opérations admin, RH, contrôles et décisions financières.",
  "whyNow": "Les dossiers récents financement, fiscalité, actionnariat et facturation montrent que la gouvernance admin/finance doit être très claire."
};
